// Formatos para números y fechas
import { toast } from "react-toastify"; // ✅ Usar react-hot-toast

export const formatos = () => {
   const formatoNumero = (numero) => {
      if (isNaN(numero)) {
         toast.error(
            `El valor proporcionado : ${numero} no es un número válido.`
         );
         return "0,00";
      }

      const numberFormat = new Intl.NumberFormat("de-DE", {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });
      return numberFormat.format(numero);
   };

   const formatoFecha = (fecha, entrada, salida) => {
      if (!fecha || fecha.length < 8) {
         toast.error(
            `El valor proporcionado : ${fecha} no es una fecha válida.`
         );
         return fecha;
      }

      if (!entrada || !salida) {
         toast.error(`Los formatos de entrada o salida no son válidos.`);
         return fecha;
      }

      if (entrada === salida) {
         toast.error(`Entrada y salida son iguales`);
         return fecha;
      }

      const formatDate = (fecha) => {
         var newDate1 = "";
         var newdate2 = "";
         if (entrada === "yyyy-mm-dd" && salida === "dd/mm/yyyy") {
            newDate1 = fecha.substring(0, 10).split("-");
            newdate2 = newDate1[2] + "/" + newDate1[1] + "/" + newDate1[0];
            return newdate2;
         } else if (entrada === "dd/mm/yyyy" && salida === "yyyy-mm-dd") {
            newDate1 = fecha.substring(0, 10).split("/");
            newdate2 = newDate1[2] + "-" + newDate1[1] + "-" + newDate1[0];
            return newdate2;
         } else if (entrada === "yyyymmdd" && salida === "yyyy-mm-dd") {
            newdate2 =
               fecha.slice(0, 4) +
               "-" +
               fecha.slice(4, 6) +
               "-" +
               fecha.slice(6, 8);
            return newdate2;
         } else if (entrada === "ddmmyyyy" && salida === "yyyy-mm-dd") {
            newdate2 =
               fecha.slice(4, 8) +
               "-" +
               fecha.slice(2, 4) +
               "-" +
               fecha.slice(0, 2);
            return newdate2;
         } else if (entrada === "yyyymmdd" && salida === "dd/mm/yyyy") {
            // Para Mostrar en pantalla
            newdate2 =
               fecha.slice(6, 8) +
               "/" +
               fecha.slice(4, 6) +
               "/" +
               fecha.slice(0, 4);
            return newdate2;
         } else {
            return fecha;
         }
      };
      return formatDate(fecha);
   };

   return {
      formatoNumero,
      formatoFecha,
   };
};
